import { State } from './state'
import { Benefit } from '@/types/Benefits.type'

export const SET_LIKED_BENEFITS = (state: State, benefits: Benefit[]) => {
    state.likedBenefits = benefits
}

export const ADD_LIKED_BENEFITS = (state: State, benefits: Benefit[]) => {
    state.likedBenefits = state.likedBenefits ? [...state.likedBenefits, ...benefits] : benefits
}

export const LIKED_BENEFITS_STARTING = (state: State) => {
    state.likedBenefitsLoaded = false
}

export const LIKED_BENEFITS_COMPLETED = (state: State) => {
    state.likedBenefitsLoaded = true
}
